// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ChargingPileSetting--next-sr-only--1YKRv1g","settingH2":"ChargingPileSetting--settingH2--36PS1IR"};